import Payment from './Payment';

export default Payment
export { Payment as Base }
